import React from "react";
import { connect } from "react-redux";
import SyntaxHighlighter from "react-syntax-highlighter";
import ReactMarkdown from "react-markdown";
import { HashLink as Link } from "react-router-hash-link-offset";
import docco from "react-syntax-highlighter/styles/hljs";
import Loader from "../../elements/Loader";
import { loadMarkdownContent } from "./actions";
import styles from "./markdown.module.scss";

const Renderer = (props) => (
  <SyntaxHighlighter language="text" style={docco}>
    {props.value}
  </SyntaxHighlighter>
);

function RouterLink(props: any) {
  return props.href.match(/^(https?:)?\/\//) ? (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  ) : (
    <Link to={`${window.location.pathname}/${props.href}`} scrollOffset={-160}>
      {props.children}
    </Link>
  );
}

function flatten(text: string, child: any) {
  return typeof child === "string"
    ? text + child
    : React.Children.toArray(child.props.children).reduce(flatten, text);
}

function HeadingRenderer(props: any) {
  const children = React.Children.toArray(props.children);
  const text = children.reduce(flatten, "");
  const slug = text
    .toLowerCase()
    .replace(/[^\w ]/g, "")
    .replace(/\s/g, "-");
  // Downgrade the header levels intentionally, h1 -> h2, h2 -> h3, etc.
  return React.createElement(
    "h" + (props.level + 1),
    { id: slug },
    props.children
  );
}

const SubHeaderRenderer = ({ level, children }) => {
  if (level === 1) {
    return "";
  }

  if (level === 2) {
    return <h3>{children}</h3>;
  }

  return children;
};

class Markdown extends React.Component<any> {
  componentDidMount() {
    const { link, path } = this.props;

    this.props.loadMarkdownContent(link, path);
  }

  render() {
    const { className = "", asSubPage } = this.props;
    const renderers: any = {
      code: Renderer,
      link: RouterLink, // @see https://github.com/rexxars/react-markdown/issues/69
      // @see https://github.com/rexxars/react-markdown/issues/29
      heading: asSubPage ? SubHeaderRenderer : HeadingRenderer,
    };

    return (
      <div
        className={`pb-2em relative ${className} ${styles.wrapper} ${
          asSubPage ? styles.asSubPage : ""
        }`}
      >
        <Loader isOpen={this.props.status.loading} />
        <ReactMarkdown
          escapeHtml={false}
          source={this.props.source}
          renderers={renderers}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  source: state.markdown.data,
  status: state.markdown.status,
});

const mapDispatchToProps = {
  loadMarkdownContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(Markdown);
